var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"href":"https://discord.com/oauth2/authorize?client_id=363395679084871681&scope=bot&permissions=2146958711","target":"_blank"}},[_vm._v("Invite the Bot")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }